export default __webpack_public_path__ + "4c76d76db0eccb9ee70c51d6b0b6596e.png";